module.exports = __webpack_public_path__ + "static/media/faq_pacientes.bafce6c6.jpg";